import React from "react";
import T from "prop-types";

import FileChooser from "2g-file-chooser";

import useImageChooser from "./hooks/useImageChooser";

function ImageChooser({ path }) {
  const imageChooser = useImageChooser(path);

  return <FileChooser {...imageChooser} />;
}

ImageChooser.propTypes = {
  path: T.string
};

export default React.memo(ImageChooser);
